import React, { useEffect } from 'react'
import { CoreButton } from 'src/components/core'
import { set as setCookie, remove as removeCookie } from 'js-cookie'
import { useLocation } from 'react-router-dom'
import { meService, intercomAuthService } from 'src/api/authentication'
import styles from './styles'
import ConnectIcon from '@material-ui/icons/SettingsEthernet'
// material
import { Container, Box, withStyles } from '@material-ui/core'

const IntercomIntegration = props => {
  const { classes } = props

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await meService()
      } catch (error) {
        // Handle specific error codes
        if (error.response?.status === 401) {
          setCookie('redirectUrl', window.location.href)
          window.location.href = '/login'
          // Add your unauthorized handling logic here
          // For example: redirect to login page
        }
      }
    }

    fetchData()
  }, []) // Add clientId as dependency

  const handleIntercomRedirect = async () => {
    intercomAuthService().then(response => {
      removeCookie('redirectUrl')

      window.open(response.data, '_self')
    })
  }

  return (
    <div className={classes.main}>
      <div className={classes.paper}>
        <div className={classes.intercomLogoHolder}>
          <Container className={classes.intercomLogoHolder}>
            <img src="/assets/logotype.png" height="40" alt="logo" />
            <Box m={1}></Box>
            <ConnectIcon color="primary"> </ConnectIcon>
            <Box m={1}></Box>
            <img src="/assets/intercom-logo.svg" height="36" alt="logo" />
          </Container>
        </div>
      </div>
      <CoreButton onClick={handleIntercomRedirect}>
        Connect to Intercom
      </CoreButton>
    </div>
  )
}

export default withStyles(styles)(IntercomIntegration)
